import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Add To Drive...")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" New Folder ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add-folder" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Delete Folder ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-add-folder" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_bottom_pop_up, {
      onHide: _ctx.hidePopUp,
      "hide-bottom-decoration": "",
      "hide-top-decoration": ""
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      body: _withCtx(() => [
        _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.addFolder }, {
          icon: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.deleteFolder }, {
          icon: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["onHide"]),
    (!!_ctx.loader)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.loader
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}